export default {
  FUTURE: "future",
  PAST: "past",
  NOW: "now",
};
